// removed by extract-text-webpack-plugin
module.exports = {"NavItem":"NavigationItem__NavItem__3p3Em","active":"NavigationItem__active__2zJdO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 76
// module chunks = 0